var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "177A1D81-BABA-4002-A16A-F31C298316BC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 870,
    height: 1042
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-0.4%",
    width: "101.1%",
    height: "101.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.567963089   0 0 0 0 0.567963089   0 0 0 0 0.567963089  0 0 0 0.298595935 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0956075175 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mini-S",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mini-S-BO-creation-2",
    transform: "translate(-1067.000000, -824.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1280,
    height: 1989
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(355.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-8"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.000000, 299.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.000000, 407.000000)",
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(0.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 670,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "UI/form/empty+icon-Copy-6",
    transform: "translate(539.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-form",
    stroke: "#D9DFE5",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 47,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "label",
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontSize: 13,
    fontWeight: 400,
    "line-spacing": 24,
    fill: "#433C35"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 15
  }, "11")), /*#__PURE__*/React.createElement("g", {
    id: "UI/picto/arrow-drop-down",
    transform: "translate(73.000000, 12.000000)",
    fill: "#748285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5714316,8 C12.6785782,8 13.5714316,7.10714656 13.5714316,6 C13.5714316,4.89285821 12.6785782,4 11.5714316,4 C10.4642898,4 9.57143164,4.89285821 9.57143164,6 C9.57143164,7.10714656 10.4642898,8 11.5714316,8 Z M12.8571498,19.7143044 C13.4107219,19.7143044 13.857151,19.2678753 13.857151,18.7143033 L13.857151,10.5714364 L14.4285803,10.5714364 L14.4285803,13.7142973 C14.4285803,14.1875121 14.8125093,14.5714412 15.2857242,14.5714412 C15.758939,14.5714412 16.142868,14.1875121 16.142868,13.7142973 L16.142868,10.0000072 C16.142868,9.05357745 15.37501,8.28571939 14.4285803,8.28571939 L8.71428776,8.28571939 C7.76785806,8.28571939 7,9.05357745 7,10.0000072 L7,13.7142973 C7,14.1875121 7.38392903,14.5714412 7.85714388,14.5714412 C8.33035873,14.5714412 8.71428776,14.1875121 8.71428776,13.7142973 L8.71428776,10.5714364 L9.28571701,10.5714364 L9.28571701,18.7143033 C9.28571701,19.2678753 9.73214611,19.7143044 10.2857182,19.7143044 C10.8392903,19.7143044 11.2857194,19.2678753 11.2857194,18.7143033 L11.2857194,14.5714412 L11.8571486,14.5714412 L11.8571486,18.7143033 C11.8571486,19.2678753 12.3035778,19.7143044 12.8571498,19.7143044 Z",
    id: "\\uF183"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoys);
export default __webpack_public_path__ + "static/media/boys.f4334b5091bd946af2f6d8a5fba05f18.svg";
export { ForwardRef as ReactComponent };